import ProfileAndVerification from "@/views/profile/ProfileAndVerification";

export default { ProfileAndVerification }